<!-- <div class="connection-language">
  <language />
</div> -->
<div style="width: 100%; height: 100%; display: flex">
  <!-- PICTURE -->
  @if (!$isMobile()) {
    <div class="background-picture"></div>
  }
  <div class="connection-container">
    <div class="form-alert-container">
      <!-- FORM -->
      <div class="form-card">
        <div class="connection-logo" alt="Logo Coyote Fleet Connect"></div>

        @if (errorMessagesDictionnary[errorKey()]) {
          <alert
            genre="muted"
            [variant]="retryConnection > 2 ? 'error' : 'warn'"
            [style.visibility]="errorMessagesDictionnary[errorKey()] ? 'visible' : 'hidden'">
            {{
              (retryConnection > 2
                ? errorMessagesDictionnary['defaultError']
                : errorMessagesDictionnary[errorKey()]
              ) | translate
            }}
            @if (errorKey() === 'idpRenault') {
              ({{ connectionService.errCodeIDP }})
            }
          </alert>
        }

        @if (loadingService.isDeletedMyUser && !errorKey()) {
          <alert genre="muted" variant="success">
            {{ 'CONNECTION.SUCCESSDELETE' | translate }}
          </alert>
        }

        <form [formGroup]="connectionForm" class="form-container" (ngSubmit)="onSubmit()">
          <mat-label>{{ 'COMMON.MAIL' | translate }}</mat-label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic" style="margin-bottom: 12px">
            <input matInput type="mail" formControlName="email" autocomplete="username" />
          </mat-form-field>
          @if (!connectionService.isRenault) {
            <mat-label>{{ 'CONNECTION.PASSWORD' | translate }}</mat-label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input
                matInput
                [type]="hide ? 'password' : 'text'"
                formControlName="password"
                autocomplete="current-password" />
              <mat-icon matSuffix (click)="hide = !hide" style="height: 16px; width: 16px; font-size: 16px">
                {{ hide ? 'visibility_off' : 'visibility' }}
              </mat-icon>
              <mat-hint align="end">{{ password.value.length || 0 }}/50</mat-hint>
              @if (password.invalid && (password.dirty || password.touched)) {
                <mat-error>
                  @if (password.hasError('minlength')) {
                    <span>{{ 'CONNECTION.PASSWORDMIN' | translate }}</span>
                  }
                  @if (password.hasError('maxlength')) {
                    <span>{{ 'CONNECTION.PASSWORDMAX' | translate }}</span>
                  }
                </mat-error>
              }
            </mat-form-field>
            <mat-checkbox formControlName="isSaveLogin">
              <p>{{ 'CONNECTION.RECONNECT' | translate }}</p>
            </mat-checkbox>
          }

          @if (connectionService.isRenault) {
            <button
              type="submit"
              matButton="filled"
              color="accent"
              class="stretch"
              [disabled]="connectionService.buttonDisabled">
              {{ 'CONNECTION.CONNECTION' | translate }}
              {{ 'CONNECTION.TORENAULT' | translate }}
            </button>
          } @else {
            <button
              type="submit"
              matButton="filled"
              color="accent"
              class="stretch"
              style="margin-top: 1rem"
              [disabled]="
                connectionService.buttonDisabled ||
                connectionForm.invalid ||
                connectionService.isLoaderReconnect ||
                !password.value
              ">
              {{
                (connectionService.isLoaderReconnect ? 'CONNECTION.INPROGRESS' : 'CONNECTION.CONNECTION')
                  | translate
              }}
            </button>
          }
          @if (!isDeviceIOS) {
            <google-signin style="display: flex; margin: 1rem 0"></google-signin>
          }
        </form>

        <div style="display: flex; flex-direction: column; margin-top: 2rem; align-items: center">
          <p class="link" (click)="forgetPassword()">
            {{ 'CONNECTION.FORGETPASSWORD' | translate }}
          </p>

          @if (!isDeviceIOS && !connectionService.isRenault) {
            <p class="link">
              <a target="_blank" href="https://business-services.moncoyote.com/">
                business-services.moncoyote.com
              </a>
            </p>
          }
        </div>
      </div>
    </div>

    <p class="version">Version {{ version }}</p>
  </div>
</div>
